var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"self-adaption-wrap"},[_c('div',{ref:"el_box",staticClass:"self-adaption-box",style:(_vm.contentStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }